import { __ } from '@wordpress/i18n';
import { PanelBody, PanelRow } from '@wordpress/components';
import { InspectorControls } from '@wordpress/block-editor';
import DynamicShortcodeInput from '../components/dynamicShortcode';
import { TestimonialPreviewImage } from '../../assets/testimonialIcons';
import { addScriptsOnBody, getElementById } from '../controls/controls';
const { serverSideRender: ServerSideRender } = wp;

const TestimonialEdit = ( { attributes, setAttributes, clientId } ) => {
	const { loadRemodal, loadScript, loadThumb, shortCodeList } =
		sp_testimonial_pro;
	const { shortcode } = attributes;

	// script load on ajax action(shortcode change without refresh).
	const scriptLoad = ( shortcodeId, sidebar = false ) => {
		let sptpBlockLoaded = false;

		const sptpBlockLoadedInterval = setInterval( function () {
			let uniqId = getElementById(
				'sp-testimonial-pro-wrapper-' + shortcodeId
			);
			if ( uniqId ) {
				if ( sidebar ) {
					addScriptsOnBody( loadRemodal );
				}
				addScriptsOnBody( loadScript );
				addScriptsOnBody( loadThumb );

				const preloader = getElementById(
					'tpro-preloader-' + shortcodeId
				);
				if ( preloader ) {
					preloader.style.opacity = '0';
					preloader.style.display = 'none';
				}

				const testimonial = getElementById(
					'sp-testimonial-pro-' + shortcodeId
				);
				if ( testimonial ) {
					testimonial.style.opacity = '1';
					testimonial.style.transition = 'opacity 0.6s';
				}
				sptpBlockLoaded = true;
				uniqId = '';
			}
			if ( sptpBlockLoaded || shortcodeId === 0 ) {
				clearInterval( sptpBlockLoadedInterval );
			}
		}, 10 );
	};

	const updateShortcode = ( updateShortcode ) => {
		setAttributes( { shortcode: updateShortcode } );
	};

	const shortcodeUpdate = ( selectedShortcode, sidebar ) => {
		updateShortcode( selectedShortcode );
		scriptLoad( selectedShortcode, sidebar );
	};

	const elements = document.querySelectorAll(
		'.sp-testimonial-pro-wrapper:not(.sp-testimonial-pro-loaded)'
	);
	if ( elements.length > 0 ) {
		scriptLoad( shortcode );
	}

	if ( attributes.preview ) {
		return <TestimonialPreviewImage />;
	}

	if ( shortCodeList.length === 0 ) {
		return (
			<div className="components-placeholder is-large sptp_block_shortcode">
				<div className="components-placeholder__label">
					<img
						className="block-editor-block-icon"
						src={
							sp_testimonial_pro.url +
							'Admin/GutenbergBlock/assets/real-testimonials-logo.svg'
						}
						alt="Real Testimonials Logo"
					/>
					<h4>{ __( 'Real Testimonials', 'testimonial-pro' ) }</h4>
				</div>
				<div className="sptp_block_shortcode_text">
					<span>
						{ __( 'No view shortcode found.', 'testimonial-pro' ) }
					</span>
					<a href={ sp_testimonial_pro.link }>
						{ __( 'Create a view now!', 'testimonial-pro' ) }
					</a>
				</div>
			</div>
		);
	}

	if ( ! attributes.shortcode || attributes.shortcode === 0 ) {
		return (
			<>
				<InspectorControls>
					<PanelBody
						title={ __(
							'Select a view (shortcode)',
							'testimonial-pro'
						) }
					>
						<PanelRow>
							<DynamicShortcodeInput
								attributes={ attributes }
								shortCodeList={ shortCodeList }
								shortcodeUpdate={ shortcodeUpdate }
								sidebar={ false }
							/>
						</PanelRow>
					</PanelBody>
				</InspectorControls>
				<div className="components-placeholder is-large sptp_block_shortcode">
					<div className="components-placeholder__label">
						<img
							className="block-editor-block-icon"
							src={
								sp_testimonial_pro.url +
								'Admin/GutenbergBlock/assets/real-testimonials-logo.svg'
							}
							alt="Real Testimonials Logo"
						/>
						<span>
							{ __( 'Real Testimonial Pro', 'testimonial-pro' ) }
						</span>
					</div>
					<div className="components-placeholder__instructions">
						{ __( 'Select a view (shortcode)', 'testimonial-pro' ) }
					</div>
					<DynamicShortcodeInput
						attributes={ attributes }
						shortCodeList={ shortCodeList }
						shortcodeUpdate={ shortcodeUpdate }
						sidebar={ false }
					/>
				</div>
			</>
		);
	}

	return (
		<>
			<InspectorControls>
				<PanelBody
					title={ __(
						'Real Testimonials Pro Block Settings',
						'testimonial-pro'
					) }
				>
					<PanelRow>
						<DynamicShortcodeInput
							attributes={ attributes }
							shortCodeList={ shortCodeList }
							shortcodeUpdate={ shortcodeUpdate }
							sidebar={ true }
						/>
					</PanelRow>
				</PanelBody>
			</InspectorControls>
			<ServerSideRender
				block="sp-testimonial-pro/shortcode"
				attributes={ attributes }
			/>
		</>
	);
};

export default TestimonialEdit;
